import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {IDataPartner} from "../../../types";
import Client from "./Client";
import ClientProps from "./ClientProps";
import {userService} from "../../../services/UserService";
import CropSensePartner from "./CropSensePartner";


interface IProps {
    partnerData: IDataPartner
    userSelectedIndex: number | null
    lastConnections: Record<string, string>
    filtroTexto: string
    filtrosTipos: number[]
    filtroParcelas: number[]
    filtroSuperficie: number[]
    filtroCultivos: string[]
    filtroEstado: number[]
    filtroCreacionInicio: Date | null
    filtroCreacionFin: Date | null
    filtroExpedicionInicio: Date | null
    filtroExpedicionFin: Date | null
    filtroUltimaConexionInicio: Date | null
    filtroUltimaConexionFin: Date | null
    filtrosActualizados: boolean
    cropsense: boolean
    setFiltrosActuaizados(actualizado: boolean): void
}

interface Istate {
}


class Clientes extends React.Component<IProps, Istate> {

    state:Istate = {
    }

    renderUsers = () => {
        let filteredUsers = [] as number[]

        for (let i = 0; i < this.props.partnerData.users.length; i++) {
            if (this.props.filtroTexto.length > 0) {
                let filtrar = true
                for (let campo of ["nombre", "nombre_usuario", "apellidos", "email"]) {
                    if (this.props.partnerData.users[i][campo] !== null) {
                        if ((this.props.partnerData.users[i][campo] as string).toLowerCase().includes(this.props.filtroTexto.toLowerCase())) {
                            filtrar = false
                        }
                    }
                }
                if (filtrar) continue
            }

            if (this.props.filtrosTipos.length > 0) {
                if (!this.props.filtrosTipos.includes(1) && this.props.partnerData.users[i]["level"] == 1) continue
                if (!this.props.filtrosTipos.includes(2) && this.props.partnerData.users[i]["level"] == 2) continue
                if (!this.props.filtrosTipos.includes(3) && this.props.partnerData.users[i]["level"] == 3) continue
                if (!this.props.filtrosTipos.includes(4) && ![1, 2, 3].includes(this.props.partnerData.users[i]["level"] as number)) continue
            }

            if (this.props.filtroParcelas.length === 2) {
                let userName = this.props.partnerData.users[i]["nombre"]
                let parcelas = this.props.partnerData.plots[userName].length
                if (parcelas < this.props.filtroParcelas[0]) continue
                if (parcelas > this.props.filtroParcelas[1]) continue
            }

            if (this.props.filtroSuperficie.length === 2) {
                let userName = this.props.partnerData.users[i]["nombre"]
                let superficie = 0
                for (let parcela of this.props.partnerData.plots[userName]) {
                    superficie += parcela["superficie"] as number
                }

                superficie = Math.round(superficie/100)/100

                if (superficie < this.props.filtroSuperficie[0]) continue
                if (superficie > this.props.filtroSuperficie[1]) continue
            }

            if (this.props.filtroCultivos.length > 0) {
                let filtrar = true
                let userName = this.props.partnerData.users[i]["nombre"]
                for (let parcela of this.props.partnerData.plots[userName]) {
                    if (this.props.filtroCultivos.includes(parcela["cultivo"] as string)) {
                        filtrar = false
                        break
                    }
                }
                if (filtrar) continue
            }

            if (this.props.filtroEstado.length > 0) {
                if (!this.props.filtroEstado.includes(this.props.partnerData.users[i]["confirmado"] as number)) continue
            }

            if (this.props.filtroCreacionInicio !== null) {
                let fechaCreacion = this.props.partnerData.users[i]["fecha_creacion"] as string
                let dateCreacion = new Date(fechaCreacion.split("-").reverse().join("/"))
                if (dateCreacion < this.props.filtroCreacionInicio) continue
            }

            if (this.props.filtroCreacionFin !== null) {
                let fechaCreacion = this.props.partnerData.users[i]["fecha_creacion"] as string
                let dateCreacion = new Date(fechaCreacion.split("-").reverse().join("/"))
                if (dateCreacion > this.props.filtroCreacionFin) continue
            }

            if (this.props.filtroExpedicionInicio !== null) {
                let fechaExpedicion = this.props.partnerData.users[i]["fecha_caducidad"] as string
                let dateExpedicion = new Date(fechaExpedicion.split("-").reverse().join("/"))
                if (dateExpedicion < this.props.filtroExpedicionInicio) continue
            }

            if (this.props.filtroExpedicionFin !== null) {
                let fechaExpedicion = this.props.partnerData.users[i]["fecha_caducidad"] as string
                let dateExpedicion = new Date(fechaExpedicion.split("-").reverse().join("/"))
                if (dateExpedicion > this.props.filtroExpedicionFin) continue
            }

            if (this.props.filtroUltimaConexionInicio !== null) {
                let fechaUltimaConexion = this.props.lastConnections[this.props.partnerData.users[i]["nombre"]]
                if (fechaUltimaConexion === "--/--/----") continue
                let dateUltimaConexion = new Date(fechaUltimaConexion.split("/").reverse().join("/"))
                if (dateUltimaConexion < this.props.filtroUltimaConexionInicio) continue
            }

            if (this.props.filtroUltimaConexionFin !== null) {
                let fechaUltimaConexion = this.props.lastConnections[this.props.partnerData.users[i]["nombre"]]
                if (fechaUltimaConexion === "--/--/----") continue
                let dateUltimaConexion = new Date(fechaUltimaConexion.split("/").reverse().join("/"))
                if (dateUltimaConexion < this.props.filtroUltimaConexionFin) continue
            }

            filteredUsers.push(i)
        }


        return (
            filteredUsers.map(index =>
                <div
                    key={index}
                    style={{
                        width: 350,
                        height: 140,
                        margin: 10
                    }}
                >
                    <Client indexClient={index}/>
                </div>
            )
        )
    }

    render() {

        if (this.props.cropsense && this.props.userSelectedIndex !== null) {
            return (
                <CropSensePartner/>
            )
        } else {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        height: '100%',
                        backgroundColor: "#ECECEC"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            width: this.props.userSelectedIndex === null? 'calc(100% - 100px)' : 'calc(100% - 500px)',
                            height: "fit-content",
                            maxHeight: 'calc(100% - 60px)',
                            marginRight: 50,
                            marginLeft: 50,
                            marginTop: 30,
                            marginBottom: 30,
                            overflowY: "auto"
                        }}
                    >
                        {this.renderUsers()}
                    </div>

                    {this.props.userSelectedIndex !== null &&
                        <div
                            style={{
                                width: 370,
                                height: 'calc(100% - 60px)',
                                marginTop: 30,
                                marginRight: 30
                            }}
                        >
                            <ClientProps/>
                        </div>
                    }

                </div>
            )
        }
    }
}

const mapStateToProps = (state: IStore) => ({
    partnerData: state.partner.dataPartner,
    userSelectedIndex: state.partner.userSelectedIndex,
    lastConnections: state.partner.lastConnections,
    filtroTexto: state.partner.filtroTexto,
    filtrosTipos: state.partner.filtroTipos,
    filtroParcelas: state.partner.filtroParcelas,
    filtroSuperficie: state.partner.filtroSuperficie,
    filtroCultivos: state.partner.filtroCultivos,
    filtroEstado: state.partner.filtroEstado,
    filtroCreacionInicio: state.partner.filtroCreacionInicio,
    filtroCreacionFin: state.partner.filtroCreacionFin,
    filtroExpedicionInicio: state.partner.filtroExpedicionInicio,
    filtroExpedicionFin: state.partner.filtroExpedicionFin,
    filtroUltimaConexionInicio: state.partner.filtroUltimaConexionInicio,
    filtroUltimaConexionFin: state.partner.filtroUltimaConexionFin,
    filtrosActualizados: state.partner.filtrosActualizados,
    cropsense: state.navegacionPartners.cropsense
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setFiltrosActuaizados: (actualizado: boolean) => dispatch({type: "set-filtros-actualizados", actualizado}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Clientes);
